import React, {
  useEffect,
  useMemo,
  useState,
} from 'react';
import PropTypes from 'prop-types';
import { useField } from 'formik';
import { isNull, isEmpty } from 'lodash';
import Swal from 'sweetalert2';
import Button from '@components/smartAdminUI/Button';
import FormikField from '../../../FormikField';

const LincNumberGenerator = ({
  fields,
  validateFigField,
}) => {
  const parcelNumberFieldMeta = useMemo(() => fields[0], [fields]);
  const [field, , helpers] = useField(parcelNumberFieldMeta.FieldName);
  const [parcelNumber, setParcelNumber] = useState('');

  useEffect(() => {
    const fieldValue = field?.value;
    if (isNull(fieldValue)) return;
    setParcelNumber(fieldValue);
    validateFigField(parcelNumberFieldMeta.FieldName, fieldValue);
  }, [field?.value]);

  const onParcelNumberGenerateClicked = async () => {
    if (fields) {
      await Swal.fire({
        allowEnterKey: false,
        allowEscapeKey: false,
        allowOutsideClick: false,
        position: 'center',
        html: 'Generating Temporary LINC Number...',
        title: '<span class="fa-stack fa-2x text-success m-3"><i class="fal fa-circle-notch fa-spin fa-stack-2x"></i><i class="fas fa-bolt fa-stack-1x"></i></span>',
        showConfirmButton: false,
        timer: 2000,
      });
      const fieldValue = `T${(Math.floor((new Date()).getTime() / 1000)).toString().slice(1)}`;
      await helpers.setValue(fieldValue);
    }
  };

  const onParcelNumberClearClicked = async () => {
    if (fields) {
      helpers.setValue('');
    }
  };

  return (
    <div className="form-row mb-3" id="ParcelNumber">
      <div className="col-md-10">
        <FormikField
          {...parcelNumberFieldMeta}
          key={parcelNumberFieldMeta.RowID}
          name={parcelNumberFieldMeta.FieldName}
          validateFigField={validateFigField}
        />
      </div>
      <div className="col-auto">
        <div className="form-group mt-4 mb-4">
          <Button
            name="btnParcelNumberClear"
            onClick={onParcelNumberClearClicked}
            variant="primary"
            disabled={parcelNumber === ''}
            tooltipText={isEmpty(parcelNumber) ? null : 'Clear LINC Number'}
          >
            <i className="far fa-times" aria-hidden="true" />
          </Button>
          <Button
            name="btnParcelNumberGenerate"
            onClick={onParcelNumberGenerateClicked}
            variant="primary"
            disabled={parcelNumber !== ''}
            tooltipText={isEmpty(parcelNumber) ? 'Generate Temporary LINC Number' : null}
          >
            <i className="fas fa-magic" aria-hidden="true" />
          </Button>
        </div>
      </div>
    </div>
  );
};

LincNumberGenerator.propTypes = {
  fields: PropTypes.arrayOf(PropTypes.shape()),
  validateFigField: PropTypes.func.isRequired,
};

export default LincNumberGenerator;
